<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <div class="ts-border ts-space-y-2 ts-p-3 ts-rounded-md">
          <div class="row">
            <div class="col-12">
              <div>
                <a-radio-group v-model="acStatusId" size="small" @change="clearInput">
                  <a-radio-button :value="1">
                    {{ $t('studentScoringEntry.current') }}
                  </a-radio-button>
                  <a-radio-button :value="2">
                    {{ $t('studentScoringEntry.history') }}
                  </a-radio-button>
                </a-radio-group>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="ts-flex ts-justify-between">
                <label class="required ts-mb-0">{{
                  $t('studentScoringEntry.academicYear')
                  }}</label>
              </div>
              <a-select v-model="model.ac_year_id" style="width: 100%" :options="academicYear" :showSearch="true"
                :filterOption="filterOption" @change="onAcYearChange"></a-select>
              <div class="ts-text-red-600" v-if="errors.has('ac_year_id')">
                {{ errors.first('ac_year_id') }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="ts-flex ts-justify-between">
                <label class="required ts-mb-0">{{
                  $t('studentScoringEntry.mainProgram')
                  }}</label>
              </div>
              <a-select v-model="model.acp_id" style="width: 100%" :options="mainPrograms" :showSearch="true"
                :filterOption="filterOption" @change="onMainProgramChange"></a-select>
              <div class="ts-text-red-600" v-if="errors.has('acp_id')">
                {{ errors.first('acp_id') }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="ts-flex ts-justify-between">
                <label class="ts-mb-0">{{
                  $t('studentScoringEntry.subProgram')
                  }}</label>
              </div>
              <a-select v-model="model.acps_id" style="width: 100%" :options="subPrograms" :showSearch="true" allowClear
                :filterOption="filterOption" @change="onSubProgramChange"></a-select>
              <div class="ts-text-red-600" v-if="errors.has('acps_id')">
                {{ errors.first('acps_id') }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="ts-flex ts-justify-between ts-mb-1">
                <label class="ts-mb-0">{{
                  $t('studentScoringEntry.academicTerm')
                  }}</label>
              </div>
              <a-select v-model="model.ac_term_id" style="width: 100%" :options="termList" :showSearch="true"
                :filterOption="filterOption" @change="onTermChange"></a-select>
              <div class="ts-text-red-600" v-if="errors.has('ac_term_id')">
                {{ errors.first('ac_term_id') }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="ts-border ts-space-y-2 ts-p-3 ts-rounded-md ts-h-full">
          <div class="row">
            <div class="col-md-12">
              <div class="ts-flex ts-justify-between ts-mb-1">
                <label class="required ts-mb-0">{{
                  $t('studentScoringEntry.academicClass')
                }}</label>
              </div>
              <a-select :value="classValue" style="width: 100%" :options="classes" :showSearch="true"
                :filterOption="filterOption" @change="onClassChange"></a-select>
              <div class="ts-text-red-600" v-if="errors.has('class_id')">
                {{ errors.first('class_id') }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="required ts-mb-0">{{
                $t('studentScoringEntry.scoringCycle')
                }}</label>
              <a-select v-model="model.scoring_cycle_id" style="width: 100%" :options="scoringCycle"
                @change="scoringCycleChange"></a-select>
              <div class="ts-text-red-600" v-if="errors.has('scoring_cycle_id')">
                {{ errors.first('scoring_cycle_id') }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div v-if="model.scoring_cycle_id != 4">
                <label class="required ts-mb-0">{{
                  $t('studentScoringEntry.scoringCycleValue')
                }}</label>

                <select style="width: 100%" v-model.number="model.cycle_value" v-if="includeValue([1, 4, 5, 7])"
                  class="form-control" @change="onCycleValue">
                  <option :value="null" disabled selected style="display: none">
                    {{ $t('select') }}
                  </option>
                  <option v-for="(s, index) in scoringCycleValuesList" :key="index" :value="s.scoring_cycle_value">
                    {{ s.scoring_cycle_description }}
                  </option>
                </select>
                <input v-model.number="model.cycle_value" type="number" style="width: 100%" class="form-control"
                  readonly v-if="includeValue([0, 2, 3])" />
                <input type="number" class="form-control" style="width: 100%" readonly
                  v-if="model.scoring_cycle_id == null" />
                <div class="ts-text-red-600" v-if="errors.has('cycle_value')">
                  {{ errors.first('cycle_value') }}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="ts-mb-0">{{ $t('studentScoringEntry.subject') }}</label>
              <a-select v-model="selectedSubjectId.id" style="width: 100%" :options="subjects" mode="multiple"
                :maxTagCount="2"></a-select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  formViewModel,
  getScoringCycle,
  getScoringCycleValue
} from '@/api/student-scoring-table-entry'
import { Errors } from 'form-backend-validation'
import { orderBy } from 'lodash'
import { mapMutations } from 'vuex'
export default {
  props: ['value', 'selectedSubjectId'],
  data() {
    return {
      errors: new Errors(),
      subjects: [],
      acStatusId: 1,
      classes: [],
      mainPrograms: [],
      subPrograms: [],
      termList: [],
      academicYear: [],
      scoringCycle: [],
      scoringCycleValues: [],
      monthlySemesterMapping: [],
      term_order: null,
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  mounted() {
    this.fetchScoringCycleValue()
    this.fetchBaseResource()
  },
  computed: {
    classValue() {
      if (this.model.class_id) {
        return this.model.class_id
      }

      return undefined;
    },
    includeValue: vm => arrayValue => {
      if (arrayValue == undefined) {
        return false
      }
      return arrayValue.includes(vm.model.scoring_cycle_id)
    },
    scoringCycleValuesList() {
      if (this.model.scoring_cycle_id) {
        if (this.model.scoring_cycle_id == 7) {
          if (this.term_order == 1) {
            return this.scoringCycleValues
              .filter(s => s.scoring_cycle_id == this.model.scoring_cycle_id)
              .filter(s => _.includes([1, 2], s.scoring_cycle_value)) // Term 1, Term 2 only for semester 1
          }
          return this.scoringCycleValues
            .filter(s => s.scoring_cycle_id == this.model.scoring_cycle_id)
            .filter(s => _.includes([3, 4, 5], s.scoring_cycle_value)) // Term 3, Term 4 and Final Exam only for semester 2
        }
        const { months } = this.monthlySemesterMapping
        if (months) {
          return this.scoringCycleValues.filter(
            s =>
              s.scoring_cycle_id == this.model.scoring_cycle_id &&
              months.includes(s.scoring_cycle_value)
          )
        }
        return this.scoringCycleValues.filter(
          s => s.scoring_cycle_id == this.model.scoring_cycle_id
        )
      }
      return this.scoringCycleValues
    },
    getAcStatusAsText: () => statuId => {
      const statusText = {
        1: 'Current',
        2: 'History',
        3: 'Next'
      }

      return statusText[statuId] || 'Unknow'
    }
  },
  methods: {
    ...mapMutations('studentScoringEntryTable', ['isLoading']),
    fetchScoringCycleValue() {
      this.isLoading(true)
      getScoringCycleValue()
        .then(response => {
          this.scoringCycleValues = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.isLoading(false)
        })
    },
    fetchBaseResource() {
      this.isLoading(true)
      formViewModel({
        params: {
          fnName: 'mainProgram,acYear',
          acStatusId: this.acStatusId
        }
      })
        .then(({ data }) => {
          this.mainPrograms = data.mainProgram.map(el => ({
            value: el.acp_id,
            label: el.acp_name_foreign
          }))

          this.academicYear = data.acYear.map(el => ({
            value: el.ac_year_id,
            label: `${el.ac_year}-${this.getAcStatusAsText(el.ac_status_id)}`
          }))

          const currenctAcYear = data.acYear.find(y => y.ac_status_id == this.acStatusId)
          if (currenctAcYear !== undefined) {
            this.model.ac_year_id = currenctAcYear.ac_year_id
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.isLoading(false)
        })
    },
    async fetchSemesterMapping() {
      const termOrder = this.termList.find(el => el.value === this.model.ac_term_id)
      formViewModel({
        params: {
          fnName: 'monthlyForSemester',
          acps_id: this.model.acps_id,
          semester_order: termOrder.order
        }
      })
        .then((response) => {
          if (response.data.monthlyForSemester) {
            this.monthlySemesterMapping = response.data.monthlyForSemester
          }
        })
    },
    async onFetchClass() {
      return formViewModel({
        params: {
          fnName: 'academicClass',
          acStatusId: this.acStatusId,
          acpId: this.model.acp_id,
          acpsId: this.model.acps_id,
          acYearId: this.model.ac_year_id,
          acTermId: this.model.ac_term_id
        }
      })
        .then(({ data }) => {
          this.classes = data.academicClass.map(el => ({
            label: `${el.class_name} | ${el.class_desc} | ${el.teacher_name}`,
            value: el.class_id,
            sch_id: el.sch_id,
            acps_id: el.acps_id,
            class_id: el.class_id,
            acp_id: el.acp_id,
            ac_year_id: el.ac_year_id,
            ac_term_id: el.ac_term_id,
            term_order: el.term_order,
            grade_id: el.grade_id,
            score_type: el.score_type, // 1 numbering, 2 grading, 3 rating
            monthly_score_sc_bas_id: el.monthly_score_sc_bas_id, // 1 item base, 2 subject base
            semester_score_sc_bas_id: el.semester_score_sc_bas_id, // 1 item base, 2 subject base
            ac_category_id: el.ac_category_id // 1 សិក្សាសង្គម, 0 Normal, 2 Sciense
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    async fetchClass() {
      this.isLoading(true)
      this.model.class_id = null
      await this.onFetchClass()
      this.isLoading(false)
    },
    async onClassChange(value, option) {
      this.$emit('clearEntities', [])
      this.model.sc_item_subject_comp_list = []
      this.subjects = [];
      this.selectedSubjectId.id = []
      const {
        acp_id,
        acps_id,
        ac_year_id,
        ac_term_id,
        term_order,
        score_type,
        ac_category_id,
        grade_id,
        subject_order,
        class_id
      } = option.data.props

      const termExist = this.termList.find(t => t.value === ac_term_id)

      this.isLoading(true)

      if (!termExist) {
        await this.fetchTerm(ac_term_id)
      }
      this.model.class_id = class_id
      this.model.acp_id = acp_id
      this.model.acps_id = acps_id
      this.model.ac_year_id = ac_year_id
      this.model.ac_term_id = ac_term_id
      this.model.scoring_cycle_id = null
      this.model.cycle_value = null
      this.model.grade_id = grade_id
      this.model.score_type = parseInt(score_type)
      this.model.ac_category_id = ac_category_id
      this.model.subject_order = subject_order
      this.term_order = term_order
      await Promise.all([
        this.fetchScoringCyle({ acps_id: acps_id }),
        this.fetchSemesterMapping()
      ])
      this.isLoading(false)
    },
    fetchScoringCyle({ acps_id }) {
      return getScoringCycle({ params: { acps_id } })
        .then(response => {
          this.scoringCycle = response.data.map(el => ({
            value: el.scoring_cycle_id,
            label: el.scoring_cycle_name
          }))
          this.$emit('fetchStudent')
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    scoringCycleChange() {
      const findClass = this.classes.find(c => c.class_id === this.model.class_id)
      if (this.model.scoring_cycle_id == 1) {
        this.model.score_sc_bas_id = parseInt(findClass.monthly_score_sc_bas_id)
      } else {
        this.model.score_sc_bas_id = parseInt(
          findClass.semester_score_sc_bas_id
        )
      }
      if ([0, 2, 3].includes(this.model.scoring_cycle_id)) {
        this.model.cycle_value = this.term_order
      } else if (this.model.scoring_cycle_id == 4) {
        this.model.cycle_value = 1
      } else {
        this.model.cycle_value = null
      }
      this.fetchEntities()
    },
    fetchEntities() {
      this.isLoading(true)
      this.subjects = [];
      return formViewModel({
        params: {
          fnName: 'scoreEntities',
          class_id: this.model.class_id,
          score_type: this.model.score_type,
          subject_order: this.model.subject_order
        }
      })
        .then(({ data }) => {
          if (data.scoreEntities !== null) {
            this.subjects = data.scoreEntities.entities.map(el => ({
              value: el.id,
              label: el.name_native + '-' + el.name
            }))

            this.selectedSubjectId.id = this.subjects.map(el => el.value)
            this.isLoading(false)
            this.$emit('scoreEntities', data.scoreEntities)
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    clearInput() {
      this.classes = []
      this.selectedSubjectId.id = []
      this.scoringCycle = []
      this.students = []
      this.term_order = null
      this.academicYear = []  
      this.model.class_id = null
      this.model.acp_id = null
      this.model.grade_id = null
      this.model.scoring_cycle_id = null
      this.model.score_type = null
      this.model.acps_id = null
      this.model.cycle_value = null
      this.model.ac_year_id = null
      this.model.ac_term_id = null
      this.model.program_structure_id = null
      this.model.sc_item_subject_comp_list = []
      this.model.subject_order = undefined
      this.fetchBaseResource()
    },
    clearInputNoFetch() {
      this.classes = []
      this.selectedSubjectId.id = []
      this.scoringCycle = []
      this.students = []
      this.term_order = null
      this.model.class_id = null
      this.model.grade_id = null
      this.model.scoring_cycle_id = null
      this.model.score_type = null
      this.model.cycle_value = null
      this.model.program_structure_id = null
      this.model.sc_item_subject_comp_list = []
      this.model.subject_order = undefined
    },
    onCycleValue() {
      this.$emit('on-cycle-value-change')
    },
    orderByClass(classes) {
      return orderBy(classes, ['ac_term_id'])
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text
        .toLowerCase()
        .indexOf(input.toLowerCase()) >= 0
    },
    async onAcYearChange() {
      this.clearInputNoFetch()
      this.model.acps_id = undefined
      this.model.acp_id = undefined
      this.subProgram = []
      this.termList = []
      this.classes = []
    },
    async onMainProgramChange() {
      this.clearInputNoFetch()
      this.model.acps_id = undefined
      this.subProgram = []
      this.termList = []
      this.isLoading(true)
      await Promise.all([
        this.onFetchClass(),
        this.fetchSubProgram()
      ])
      this.isLoading(false)
    },
    async fetchSubProgram() {
      await formViewModel({
        params: {
          fnName: 'subProgram',
          acpId: this.model.acp_id,
          acYearId: this.model.ac_year_id,
          acStatusId: this.acStatusId,
        }
      })
        .then(({ data }) => {
          this.subPrograms = data.subProgram.map(el => ({
            value: el.acps_id,
            label: el.acps_name_foreign
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    async fetchTerm(acTermId) {
      await formViewModel({
        params: {
          fnName: 'acTerm',
          acpsId: this.model.acps_id,
          acStatusId: this.acStatusId,
          acYearId: this.model.ac_year_id,
          acTermId
        }
      })
        .then(({ data }) => {
          this.termList = data.acTerm.map(el => ({
            value: el.ac_term_id,
            label: el.term_name,
            order: el.term_order
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    async onSubProgramChange() {
      this.clearInputNoFetch()
      this.model.ac_term_id = undefined
      this.termList = []
      this.isLoading(true)
      await Promise.all([
        this.fetchTerm(),
        this.onFetchClass()
      ])
      this.isLoading(false)
    },
    async onTermChange() {
      this.clearInputNoFetch()
      this.fetchClass()
    }
  }
}
</script>
